import { render, staticRenderFns } from "./AnalyzesPendingToBeSent.vue?vue&type=template&id=e4af8b54&"
import script from "./AnalyzesPendingToBeSent.vue?vue&type=script&lang=ts&"
export * from "./AnalyzesPendingToBeSent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports